import Themes from './themes'

export default function () {
  const supported = {}

  Object.entries(Themes).forEach(([name, theme]) => {
    // The only way to not support a theme is for it to define an `isSupported`
    // function that returns false. Otherwise, support it by default.
    if (typeof theme.isSupported === 'function' && !theme.isSupported()) return
    supported[name] = Object.assign({}, theme)
  })

  return supported
}
